import { combineReducers } from "@reduxjs/toolkit";
import backoffice from "../backoffice";
import { appSlice } from "./app/appSlice";
import { autonomySlice } from "./autonomy/autonomySlice";
import { coinsSlice } from "./coins/coinsSlice";
import { scoreSlice } from "./coins/scoreSlice";
import { configSlice } from "./config/configSlice";
import { ExampleSlice } from "./example/ExampleSlice";
import { FleetSlice } from "./fleets/fleetsSlice";
import { langSlice } from "./lang/langSlice";
import { LoginSlice } from "./login/LoginSlice";
import { RoutesSlice } from "./routes/RoutesSlice";
import { SidebarSlice } from "./sidebar/SidebarSlice";
import { TokenSlice } from "./token/TokenSlice";
import { TripsSlice } from "./trips/TripsSlice";
import { userSlice } from "./user/userSlice";

export const reducers = combineReducers({
  example: ExampleSlice.reducer,
  sidebar: SidebarSlice.reducer,
  routes: RoutesSlice.reducer,
  trips: TripsSlice.reducer,
  lang: langSlice.reducer,
  config: configSlice.reducer,
  app: appSlice.reducer,
  user: userSlice.reducer,
  login: LoginSlice.reducer,
  tokenHandling: TokenSlice.reducer,
  fleet: FleetSlice.reducer,
  coins: coinsSlice.reducer,
  score: scoreSlice.reducer,
  autonomy: autonomySlice.reducer,
  backoffice: backoffice.reducers.backofficeChallenges,
  backofficeNavigationTips: backoffice.reducers.backofficeNavigationTips,
});
